const centerVRouter = () => {
    return [
        {
            path: 'center',
            name: 'centerV',
            component: () => import(/* webpackChunkName: "center-v" */'../../modules/center-v/index.vue')
        },
        {
            path: 'center/director/study/push/:id',
            name: 'directorPushDetail',
            component: () => import(/* webpackChunkName: "center-v" */'../../modules/center-v/center-detail/director/StudyPushDetail.vue')
        },
        {
            path: 'center/director/study/team/:id',
            name: 'directorTeamDetail',
            component: () => import(/* webpackChunkName: "center-v" */'../../modules/center-v/center-detail/director/StudyTeamDetail.vue')
        },
        {
            path: 'center/preview/:id/:lang/:previewFront',
            name: 'centerPreview',
            component: () => import(/* webpackChunkName: "center-v" */'../../modules/center-v/index.vue')
        },
        {
            path: 'center/student-study-pack-detail/:id',
            name: 'studentPackDetail',
            component: () => import(/* webpackChunkName: "center-detail" */'../../modules/center-v/center-detail/student/StudyPackDetail.vue')
        },
        {
            path: 'center/student-todo-menu/:currentComponent',
            name: 'studentTodoMenu',
            component: () => import(/* webpackChunkName: "center-detail" */'../../modules/center-v/office-menu.vue')
        },
    ];
};
export default centerVRouter;
